(function () {

    function formatNumber(n) {
        return Math.round(n).toLocaleString('fr-FR');
    }

    function animateCounter(el) {
        const target   = parseInt(el.dataset.target, 10);
        const duration = 1800;
        let start      = null;

        function ease(t) {
            return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
        }

        function step(timestamp) {
            if (!start) start = timestamp;
            const progress = Math.min((timestamp - start) / duration, 1);
            el.textContent = formatNumber(ease(progress) * target);
            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                el.textContent = formatNumber(target);
            }
        }

        requestAnimationFrame(step);
    }

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            animateCounter(el);
            observer.unobserve(el);
        });
    }, { threshold: 0.1 });

    document.querySelectorAll('.number').forEach(function (el) {
        observer.observe(el);
    });

})();